import { render, staticRenderFns } from "./SlideToUnlock.vue?vue&type=template&id=ef88f4d0&scoped=true&"
import script from "./SlideToUnlock.vue?vue&type=script&lang=js&"
export * from "./SlideToUnlock.vue?vue&type=script&lang=js&"
import style0 from "./SlideToUnlock.vue?vue&type=style&index=0&id=ef88f4d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef88f4d0",
  null
  
)

export default component.exports